module.exports = __webpack_public_path__ + "img/cars-small.ec0e35dc.webp";